import FormControl from "@ui-kit/form/FormControl/FormControl.web";
import FormLabel from "@ui-kit/form/FormLabel/FormLabel.web";

import { PhoneCountryType } from "@shared/lib/libphonenumber/api";
import { useTranslation } from "@shared/utils/internationalization";
import DetailedInput from "@ui-kit/form/DetailedInput/DetailedInput.web";
import FormErrorMessage from "@ui-kit/form/FormErrorMessage/FormErrorMessage.web";
import PhoneNumberInput from "@ui-kit/form/PhoneNumberInput/PhoneNumberInput.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { Controller, useFormContext } from "react-hook-form";

/**
 * Form UI for the Checkout purchaser info.
 * The form provider will be placed higher up in the tree, for other components to reference
 * form related logic such as `isValid`.
 */
function PurchaserInfoForm({
  handlePhoneCountryChange,
}: {
  handlePhoneCountryChange: (phoneCountry: PhoneCountryType) => void;
}) {
  const { control, trigger } = useFormContext();
  const { t } = useTranslation("checkout");

  return (
    <Flex direction="column" gap="md" mb="xl">
      <DetailedInput
        name="nameOnTicket"
        label={t("Full name")}
        helperText={t("This will be the name displayed on the ticket")}
        inputProps={{
          placeholder: t("Full name"),
        }}
        required
      />
      <DetailedInput
        name="email"
        label={t("Email address")}
        helperText={t(
          "Tickets and receipts will be sent to this email address"
        )}
        inputProps={{
          placeholder: t("Email address"),
          type: "email",
          autoComplete: "email",
        }}
        required
      />
      <Controller
        name="phoneNumber"
        control={control}
        render={({ field, fieldState }) => (
          <FormControl isInvalid={Boolean(fieldState.error?.message)}>
            <FormLabel htmlFor="phoneNumber" fontWeight={600} fontSize="sm">
              {t("Phone number")}
            </FormLabel>
            <PhoneNumberInput
              {...field}
              placeholder={t("Phone number")}
              handleSetPhone={(value, country) => {
                field.onChange(value);
                handlePhoneCountryChange(country);
                trigger("phoneNumber");
              }}
              countryInput={field.value}
              phoneInput={field.value}
              data-testid="phone-number-input"
              fontSize="sm"
              color="font.dark"
            />
            <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
          </FormControl>
        )}
      />
    </Flex>
  );
}

export default PurchaserInfoForm;
